import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function DefaultProvisionTextContent(props) {
  const { index, data, storeName } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [height, setHeight] = useState(0);
  const componentRef = useRef(null);

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        setHeight(entry.contentRect.height); // 변경된 높이를 상태에 저장
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    
    if (componentRef.current) {
      resizeObserver.observe(componentRef.current); // ref를 사용하여 관찰 시작
    }

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <TopLevelWrapper ref={componentRef} isFirst={index === 0}>
      <HistoryTextWrapper width={146}>
        <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{data.title}</PreText>
      </HistoryTextWrapper>
      <DivisionLine height={height} backgroundColor={theme.line} />
      <HistoryTextWrapper width={950}>
        <PreText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='default'>{data.text.replaceAll('[센터 이름]', storeName)}</PreText>
      </HistoryTextWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;

  border-top: ${props => props.isFirst ? '0px' : `2px solid ${props.theme.line}`};
`;

const HistoryTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 18px;

  width: ${props => props.width}px;
`;

const DivisionLine = styled.div`
  width: 2px;
  height: ${props => props.height}px;

  background-color: ${props => props.backgroundColor};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const PreText = styled.pre`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: pre-wrap;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;